import { render, staticRenderFns } from "./AddVasteKlantenBestelling.vue?vue&type=template&id=22bf915e&scoped=true&"
import script from "./AddVasteKlantenBestelling.vue?vue&type=script&lang=js&"
export * from "./AddVasteKlantenBestelling.vue?vue&type=script&lang=js&"
import style0 from "./AddVasteKlantenBestelling.vue?vue&type=style&index=0&id=22bf915e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf915e",
  null
  
)

export default component.exports